import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'save-tag',
  styleUrl: 'save-tag.scss',
  shadow: true
})
export class SaveTag {
  @Prop() savePercentage!: string;

  render() {
    const parsed = Number(this.savePercentage);

    if (!isFinite(parsed)) {
      console.warn('Invalid savePercentage:', this.savePercentage);
      return null;
    }

    // Truncate to 2 decimal places
    // const truncated = Math.trunc(parsed * 100) / 100;

    // const formatted = truncated.toString().replace(/\.?0+$/, '');

    return (
      <Host>
        <slot>
          <div class="tag-gradient-bg text-white text-xs font-bold rounded-tl-full rounded-bl-full py-2 px-2">SAVE {this.savePercentage}%</div>
        </slot>
      </Host>
    );
  }
}
